export function localize(field, lang) {
  if (field == null) return "";
  if (typeof field === "string") return field;
  if (Array.isArray(field)) return field;
  return field[lang] || field.de || Object.values(field)[0] || "";
}

export const LANGS = [
  { code: "de", label: "DE" },
  { code: "fr", label: "FR" },
  { code: "it", label: "IT" },
  { code: "en", label: "EN" },
];

export const translations = {
  de: {
    "nav.discover": "Entdecken",
    "nav.switchPortal": "Portal wechseln",
    "nav.dashboard": "Dashboard",
    "nav.login": "Anmelden",
    "nav.logout": "Abmelden",
    "nav.control": "Control OS",
    "nav.portals": "Portale",
    "nav.overview": "Übersicht",
    "nav.activity": "Aktivität",
    "common.loading": "Wird geladen …",
    "common.back": "Zurück",
    "common.cancel": "Abbrechen",
    "common.save": "Speichern",
    "common.saved": "Gespeichert",
    "common.close": "Schliessen",
    "common.all": "Alle",
    "common.search": "Suchen",
    "common.results": "Ergebnisse",
    "common.none": "Keine Einträge",
    "common.readAll": "Alle gelesen",
    "landing.exploreProviders": "Anbieter entdecken",
    "landing.becomeProvider": "Anbieter werden",
    "landing.categories": "Kategorien",
    "landing.featured": "Empfohlene Anbieter",
    "landing.viewAll": "Alle ansehen",
    "landing.trusted": "Kuratiert vom KEWAG-Team",
    "landing.providersLabel": "geprüfte Anbieter",
    "auth.signIn": "Anmelden",
    "auth.signUp": "Registrieren",
    "auth.email": "E-Mail",
    "auth.password": "Passwort",
    "auth.name": "Name",
    "auth.asProvider": "Als Anbieter registrieren",
    "auth.continueGoogle": "Mit Google fortfahren",
    "auth.or": "oder",
    "auth.noAccount": "Noch kein Konto?",
    "auth.haveAccount": "Bereits registriert?",
    "auth.welcome": "Willkommen zurück",
    "auth.createAccount": "Konto erstellen",
    "auth.forgotPassword": "Passwort vergessen?",
    "auth.loginTrouble": "Probleme beim Login? KEWAG Support kontaktieren",
    "auth.teamHint": "Gehörst du zum KEWAG-Team?",
    "auth.controlLogin": "Zum Control-OS-Login",
    "authx.encrypted": "Verschlüsselte Verbindung",
    "authx.securedArea": "Geschützter Bereich",
    "authx.customerAccess": "App-Zugang",
    "auth.accountType": "Ich registriere mich als",
    "auth.selectAccountType": "Bitte Kontotyp wählen",
    "auth.acceptTerms": "Ich akzeptiere die AGB und die Datenschutzerklärung.",
    "auth.termsRequired": "Bitte AGB & Datenschutz akzeptieren.",
    "auth.teamAccess": "Team-Zugang",
    "auth.hasAccount": "Bereits registriert?",
    "auth.noAccount": "Neu hier?",
    "onb.title": "Profil vervollständigen",
    "onb.subtitle": "Nur noch ein paar Angaben – dann bist du startklar.",
    "onb.step": "Schritt 2 von 2",
    "onb.later": "Später erledigen",
    "onb.finish": "Speichern & ins Cockpit",
    "browse.filters": "Filter",
    "browse.allCategories": "Alle Kategorien",
    "browse.allLocations": "Alle Orte",
    "browse.noResults": "Keine Anbieter gefunden",
    "provider.about": "Über uns",
    "provider.contact": "Kontakt",
    "provider.sendInquiry": "Anfrage senden",
    "provider.subject": "Betreff",
    "provider.message": "Nachricht",
    "provider.send": "Senden",
    "provider.reviews": "Bewertungen",
    "provider.pendingNote": "Dieses Profil wartet auf Freigabe.",
    "provider.inquirySent": "Anfrage gesendet!",
    "provider.loginToInquire": "Zum Anfragen anmelden",
    "dash.welcome": "Willkommen",
    "dash.overview": "Übersicht",
    "dash.inbox": "Anfrage-Inbox",
    "dash.myInquiries": "Meine Anfragen",
    "dash.approvals": "Freigaben",
    "dash.providers": "Anbieter",
    "dash.myProfile": "Mein Profil",
    "dash.packages": "Pakete",
    "dash.notifications": "Benachrichtigungen",
    "stat.providers": "Anbieter",
    "stat.approved": "Freigegeben",
    "stat.pending": "Ausstehend",
    "stat.inquiries": "Anfragen",
    "stat.open_inquiries": "Offene Anfragen",
    "stat.rating": "Bewertung",
    "stat.reviews": "Rezensionen",
    "status.new": "Neu",
    "status.in_progress": "In Bearbeitung",
    "status.quoted": "Offeriert",
    "status.accepted": "Angenommen",
    "status.closed": "Abgeschlossen",
    "status.rejected": "Abgelehnt",
    "status.pending": "Ausstehend",
    "status.approved": "Freigegeben",
    "inbox.select": "Anfrage auswählen",
    "inbox.timeline": "Verlauf",
    "inbox.updateStatus": "Status ändern",
    "inbox.reply": "Antworten …",
    "inbox.send": "Senden",
    "inbox.customer": "Kund:in",
    "inbox.provider": "Anbieter",
    "approve.approve": "Freigeben",
    "approve.reject": "Ablehnen",
    "approve.reason": "Grund (optional)",
    "approve.empty": "Keine ausstehenden Freigaben",
    "profile.businessName": "Firmenname",
    "profile.categories": "Kategorien",
    "profile.location": "Standort",
    "profile.description": "Beschreibung",
    "profile.phone": "Telefon",
    "profile.website": "Website",
    "profile.cover": "Titelbild-URL",
    "profile.create": "Profil erstellen",
    "profile.status": "Status",
    "pkg.current": "Aktuelles Paket",
    "pkg.choose": "Wählen",
    "pkg.subscribe": "Abonnieren",
    "pkg.month": "Monat",
    "pkg.free": "Kostenlos",
    "pkg.active": "Aktiv",
    "control.title": "KEWAG Control OS",
    "control.subtitle": "Portalübergreifende Aggregation",
    "control.totalProviders": "Anbieter gesamt",
    "control.totalInquiries": "Anfragen gesamt",
    "control.totalUsers": "Mitglieder gesamt",
    "control.pending": "Offene Freigaben",
    "control.live": "Live",
    "control.skeleton": "Skeleton",
    "control.copyable": "In 1–2 Tagen kopierbar",
    "control.openPortal": "Portal öffnen",
    "control.recentActivity": "Letzte Aktivität",
    "control.commandCenter": "Command Center",
    "control.allClear": "Alles im grünen Bereich",
    "control.needsAttention": "Punkte brauchen Aufmerksamkeit",
    "control.today": "Heute wichtig",
    "control.todaySub": "Was jetzt deine Aufmerksamkeit braucht",
    "control.review": "Jetzt ansehen",
    "kpi.providers": "Anbieter gesamt",
    "kpi.inquiries7d": "Neue Anfragen (7T)",
    "kpi.approvals": "Offene Freigaben",
    "kpi.subscriptions": "Aktive Abos",
    "kpi.registrations7d": "Neue Registrierungen (7T)",
    "kpi.security": "Sicherheits-Alerts",
    "kpi.revenue": "Umsatz (bezahlt)",
    "kpi.vsPrev": "ggü. Vorwoche",
    "kpi.new7d": "neu (7T)",
    "task.approvals": "Freigaben ausstehend",
    "task.inquiries": "Neue Anfragen",
    "task.overdue": "Überfällige Rechnungen",
    "task.security": "Sicherheits-Alerts",
    "task.emptyTitle": "Alles erledigt",
    "task.emptySub": "Keine offenen Aufgaben – gut gemacht.",
    "act.empty": "Noch keine Aktivität aufgezeichnet.",
    "act.provider.approve": "Anbieter freigegeben",
    "act.provider.reject": "Anbieter abgelehnt",
    "act.membership.update": "Mitgliedschaft geändert",
    "act.provider.create": "Anbieter erstellt",
    "act.job.create": "Stelle erstellt",
    "act.job.approve": "Stelle freigegeben",
    "act.application.create": "Bewerbung eingegangen",
    "act.candidate.upsert": "Kandidatenprofil aktualisiert",
    "act.inquiry.create": "Neue Anfrage",
    "act.inquiry.status": "Anfrage-Status geändert",
    "act.document.upload": "Dokument hochgeladen",
    "act.document.update": "Dokument aktualisiert",
    "act.document.delete": "Dokument gelöscht",
    "sec.failed7d": "Fehlgeschlagene Logins (7T)",
    "sec.logins7d": "Logins (7T)",
    "sec.lastEvents": "Letzte Ereignisse",
    "sec.allGood": "Keine Auffälligkeiten",
    "card.members": "Mitglieder",
    "card.approved": "Freigegeben",
    "card.synced": "Synchronisiert",
    "matrix.title": "Portal Health Matrix",
    "matrix.sub": "Alle Portale auf einen Blick – Zustand, Freigaben, Anfragen, Umsatz & Sync.",
    "matrix.col.portal": "Portal",
    "matrix.col.status": "Status",
    "matrix.col.health": "Zustand",
    "matrix.col.providers": "Anbieter",
    "matrix.col.approvals": "Freigaben",
    "matrix.col.inquiries": "Anfragen",
    "matrix.col.packages": "Pakete",
    "matrix.col.invoices": "Rechnungen",
    "matrix.col.revenue": "Umsatz",
    "matrix.col.sync": "WP Sync",
    "matrix.health.ok": "OK",
    "matrix.health.watch": "Beobachten",
    "matrix.health.risk": "Risiko",
    "matrix.sync.synced": "Synchronisiert",
    "matrix.sync.error": "Fehler",
    "matrix.sync.planned": "Geplant",
    "matrix.empty": "Keine Portale sichtbar.",
    "nav.readiness": "Live-Readiness",
    "ready.title": "Production Health Matrix",
    "ready.sub": "Ehrlicher Live-Status je Portal – was verbunden, konfiguriert, fehlt oder Demo ist. Keine Fake-Live-Daten.",
    "ready.legend": "Grün = verbunden/konfiguriert · Blau = Seed-Daten · Amber = nicht verbunden/Demo · Rot = Fehler",
    "ready.col.portal": "Portal",
    "ready.col.email": "E-Mail (Brevo)",
    "ready.col.wordpress": "WordPress",
    "ready.col.payments": "Payments",
    "ready.col.data": "Daten",
    "ready.state.configured": "Konfiguriert",
    "ready.state.connected": "Verbunden",
    "ready.state.live": "Live",
    "ready.state.synthetic": "Seed-Daten",
    "ready.state.demo": "Demo",
    "ready.state.mixed": "Teils Demo",
    "ready.state.not_configured": "Nicht konfiguriert",
    "ready.state.not_connected": "Nicht verbunden",
    "ready.state.gateway_not_connected": "Kein Gateway",
    "ready.state.empty": "Leer",
    "ready.state.error": "Fehler",
    "marker.not_configured": "Nicht konfiguriert",
    "marker.gateway_not_connected": "Zahlungs-Gateway nicht verbunden",
    "marker.database_only": "Nur Datenbank – kein echtes Zahlungs-Gateway",
    "marker.demo": "Demo-Daten",
    "marker.synthetic": "Seed-Daten (synthetisch)",
    "marker.connected": "Verbunden",
    "marker.error": "Fehler",
    "marker.payments.note": "Zahlungen laufen aktuell nur als Datensatz – kein echtes Gateway (Stripe/TWINT/Bexio) verbunden.",
    "dash.favorites": "Favoriten",
    "dash.account": "Profil",
    "dash.settings": "Einstellungen",
    "account.personalData": "Persönliche Daten",
    "account.name": "Name",
    "account.email": "E-Mail",
    "account.phone": "Telefon",
    "account.preferences": "Präferenzen",
    "account.language": "Sprache",
    "account.emailNotifs": "E-Mail-Benachrichtigungen",
    "account.emailNotifsHint": "Werden erst zugestellt, wenn der E-Mail-Versand (Brevo) konfiguriert ist.",
    "fav.discover": "Anbieter suchen …",
    "fav.onlyFavorites": "Nur Favoriten",
    "fav.none": "Noch keine Favoriten – tippe auf das Herz, um Anbieter zu speichern.",
    "fav.empty": "Keine Anbieter gefunden.",
    "fav.add": "Zu Favoriten",
    "fav.remove": "Aus Favoriten entfernen",
    "control.documents": "Dokumente",
    "control.documentsSub": "Verträge, Nachweise & Unterlagen über alle Portale – geschützt & rollenbasiert.",
    "navgroup.overview": "Überblick",
    "navgroup.management": "Verwaltung",
    "navgroup.insights": "Einblicke",
    "control.noTeam": "Kein Zugriff — nur für das KEWAG-Team.",
    "dir.title": "KEWAGPortal",
    "dir.subtitle": "Ein Core. Viele Marken. Build once, configure often.",
    "dir.enter": "Portal öffnen",
    "dir.controlCta": "Zum Control OS",
    "dash.ads": "Werbung",
    "dash.gallery": "Galerie",
    "promo.add": "Promotion hinzufügen",
    "promo.none": "Keine Promotionen",
    "promo.active": "Aktiv",
    "promo.delete": "Löschen",
    "media.uploadCover": "Titelbild hochladen",
    "media.uploadGallery": "Bild hinzufügen",
    "media.uploading": "Lädt hoch …",
    "media.remove": "Entfernen",
    "control.users": "Benutzer",
    "control.logs": "Logs",
    "control.security": "Security-Log",
    "control.approvals": "Freigaben",
    "control.role": "Rolle",
    "control.status": "Status",
    "control.suspend": "Sperren",
    "control.activate": "Aktivieren",
    "control.userMgmt": "Benutzer & Rollen",
    "control.searchUser": "Benutzer suchen …",
    "promo.new": "Neue Promotion",
    "promo.edit": "Bearbeiten",
    "promo.title": "Titel",
    "promo.subtitle": "Untertitel",
    "promo.imageUrl": "Bild",
    "promo.link": "Link",
    "promo.inactive": "Inaktiv",
    "nav.more": "Mehr",
    "nav.menu": "Menü",
    "dash.managePackages": "Pakete verwalten",
    "pkg.name": "Paketname",
    "pkg.price": "Preis",
    "pkg.features": "Leistungen",
    "pkg.featuresHint": "Eine Leistung pro Zeile",
    "pkg.tier": "Stufe",
    "pkg.new": "Neues Paket",
    "pkg.setupFee": "Einrichtung",
    "control.tabProviders": "Anbieter",
    "control.tabUsers": "Benutzer",
    "control.tabPackages": "Pakete",
    "control.subscribers": "Abonnenten",
    "control.customers": "Kunden",
    "control.details": "Details",
    "control.revenue": "Umsatz",
    "control.openInvoices": "Offene Rechnungen",
    "nav.reports": "Reports",
    "dash.invoices": "Rechnungen",
    "dash.report": "Report",
    "inv.new": "Neue Rechnung",
    "inv.provider": "Anbieter",
    "inv.amount": "Betrag",
    "inv.due": "Fällig am",
    "inv.method": "Zahlungsart",
    "inv.externalId": "Externe Nr.",
    "inv.notes": "Notiz",
    "inv.markPaid": "Als bezahlt markieren",
    "inv.none": "Keine Rechnungen",
    "inv.draft": "Entwurf",
    "inv.open": "Offen",
    "inv.paid": "Bezahlt",
    "inv.overdue": "Überfällig",
    "inv.cancelled": "Storniert",
    "rep.inquiries": "Anfragen",
    "rep.newProviders": "Neue Anbieter",
    "rep.revenue": "Umsatz",
    "rep.monthly": "Monatsverlauf",
    "rep.openInvoices": "Offene Rechnungen",
    "rep.profileStatus": "Profilstatus",
    "rep.package": "Paket",
    "map.title": "WordPress-Verknüpfung",
    "map.wpUrl": "WordPress-URL",
    "map.listingId": "Directorist-Listing-ID",
    "map.publicUrl": "Öffentliche Profil-URL",
    "map.markSynced": "Als synchronisiert markieren",
    "map.lastSync": "Letzter Sync",
    "map.edit": "Verknüpfung",
    "sync.synced": "Synchronisiert",
    "sync.pending": "Ausstehend",
    "sync.not_linked": "Nicht verknüpft",
    "sync.error": "Fehler",
    "roles.super_admin": "Super-Admin",
    "roles.team_member": "KEWAG-Team",
    "roles.portal_admin": "Portal-Admin",
    "roles.provider": "Anbieter",
    "roles.customer": "Kunde",
    "roles.candidate": "Bewerber:in",
  },
  fr: {
    "nav.discover": "Découvrir",
    "nav.switchPortal": "Changer de portail",
    "nav.dashboard": "Tableau de bord",
    "nav.login": "Connexion",
    "nav.logout": "Déconnexion",
    "nav.control": "Control OS",
    "nav.portals": "Portails",
    "nav.overview": "Aperçu",
    "nav.activity": "Activité",
    "common.loading": "Chargement …",
    "common.back": "Retour",
    "common.cancel": "Annuler",
    "common.save": "Enregistrer",
    "common.saved": "Enregistré",
    "common.close": "Fermer",
    "common.all": "Tous",
    "common.search": "Rechercher",
    "common.results": "résultats",
    "common.none": "Aucune entrée",
    "common.readAll": "Tout lu",
    "landing.exploreProviders": "Découvrir les prestataires",
    "landing.becomeProvider": "Devenir prestataire",
    "landing.categories": "Catégories",
    "landing.featured": "Prestataires en vedette",
    "landing.viewAll": "Voir tout",
    "landing.trusted": "Sélectionné par l'équipe KEWAG",
    "landing.providersLabel": "prestataires vérifiés",
    "auth.signIn": "Connexion",
    "auth.signUp": "S'inscrire",
    "auth.email": "E-mail",
    "auth.password": "Mot de passe",
    "auth.name": "Nom",
    "auth.asProvider": "S'inscrire comme prestataire",
    "auth.continueGoogle": "Continuer avec Google",
    "auth.or": "ou",
    "auth.noAccount": "Pas de compte ?",
    "auth.haveAccount": "Déjà inscrit ?",
    "auth.welcome": "Bon retour",
    "auth.createAccount": "Créer un compte",
    "auth.forgotPassword": "Mot de passe oublié ?",
    "auth.loginTrouble": "Problème de connexion ? Contacter le support KEWAG",
    "auth.teamHint": "Vous faites partie de l'équipe KEWAG ?",
    "auth.controlLogin": "Accès Control OS",
    "authx.encrypted": "Connexion chiffrée",
    "authx.securedArea": "Espace protégé",
    "authx.customerAccess": "Accès app",
    "auth.accountType": "Je m'inscris en tant que",
    "auth.selectAccountType": "Veuillez choisir un type de compte",
    "auth.acceptTerms": "J'accepte les CGU et la politique de confidentialité.",
    "auth.termsRequired": "Veuillez accepter les CGU et la confidentialité.",
    "auth.teamAccess": "Accès équipe",
    "auth.hasAccount": "Déjà inscrit ?",
    "auth.noAccount": "Nouveau ici ?",
    "onb.title": "Compléter le profil",
    "onb.subtitle": "Encore quelques informations et c'est prêt.",
    "onb.step": "Étape 2 sur 2",
    "onb.later": "Plus tard",
    "onb.finish": "Enregistrer & ouvrir le cockpit",
    "browse.filters": "Filtres",
    "browse.allCategories": "Toutes catégories",
    "browse.allLocations": "Tous lieux",
    "browse.noResults": "Aucun prestataire trouvé",
    "provider.about": "À propos",
    "provider.contact": "Contact",
    "provider.sendInquiry": "Envoyer une demande",
    "provider.subject": "Sujet",
    "provider.message": "Message",
    "provider.send": "Envoyer",
    "provider.reviews": "Avis",
    "provider.pendingNote": "Ce profil attend une approbation.",
    "provider.inquirySent": "Demande envoyée !",
    "provider.loginToInquire": "Se connecter pour demander",
    "dash.welcome": "Bienvenue",
    "dash.overview": "Aperçu",
    "dash.inbox": "Boîte de demandes",
    "dash.myInquiries": "Mes demandes",
    "dash.approvals": "Approbations",
    "dash.providers": "Prestataires",
    "dash.myProfile": "Mon profil",
    "dash.packages": "Forfaits",
    "dash.notifications": "Notifications",
    "stat.providers": "Prestataires",
    "stat.approved": "Approuvés",
    "stat.pending": "En attente",
    "stat.inquiries": "Demandes",
    "stat.open_inquiries": "Demandes ouvertes",
    "stat.rating": "Note",
    "stat.reviews": "Avis",
    "status.new": "Nouveau",
    "status.in_progress": "En cours",
    "status.quoted": "Devis",
    "status.accepted": "Accepté",
    "status.closed": "Clôturé",
    "status.rejected": "Rejeté",
    "status.pending": "En attente",
    "status.approved": "Approuvé",
    "inbox.select": "Sélectionner une demande",
    "inbox.timeline": "Historique",
    "inbox.updateStatus": "Changer le statut",
    "inbox.reply": "Répondre …",
    "inbox.send": "Envoyer",
    "inbox.customer": "Client",
    "inbox.provider": "Prestataire",
    "approve.approve": "Approuver",
    "approve.reject": "Rejeter",
    "approve.reason": "Raison (facultatif)",
    "approve.empty": "Aucune approbation en attente",
    "profile.businessName": "Nom de l'entreprise",
    "profile.categories": "Catégories",
    "profile.location": "Lieu",
    "profile.description": "Description",
    "profile.phone": "Téléphone",
    "profile.website": "Site web",
    "profile.cover": "URL image",
    "profile.create": "Créer le profil",
    "profile.status": "Statut",
    "pkg.current": "Forfait actuel",
    "pkg.choose": "Choisir",
    "pkg.subscribe": "S'abonner",
    "pkg.month": "mois",
    "pkg.free": "Gratuit",
    "pkg.active": "Actif",
    "control.title": "KEWAG Control OS",
    "control.subtitle": "Agrégation inter-portails",
    "control.totalProviders": "Prestataires",
    "control.totalInquiries": "Demandes",
    "control.totalUsers": "Membres",
    "control.pending": "Approbations ouvertes",
    "control.live": "En ligne",
    "control.skeleton": "Squelette",
    "control.copyable": "Copiable en 1–2 jours",
    "control.openPortal": "Ouvrir le portail",
    "control.recentActivity": "Activité récente",
    "control.commandCenter": "Command Center",
    "control.allClear": "Tout est au vert",
    "control.needsAttention": "points requièrent votre attention",
    "control.today": "Important aujourd'hui",
    "control.todaySub": "Ce qui requiert votre attention",
    "control.review": "Consulter",
    "kpi.providers": "Prestataires (total)",
    "kpi.inquiries7d": "Nouvelles demandes (7j)",
    "kpi.approvals": "Approbations ouvertes",
    "kpi.subscriptions": "Abos actifs",
    "kpi.registrations7d": "Nouvelles inscriptions (7j)",
    "kpi.security": "Alertes de sécurité",
    "kpi.revenue": "Chiffre d'affaires (payé)",
    "kpi.vsPrev": "vs semaine préc.",
    "kpi.new7d": "nouv. (7j)",
    "task.approvals": "Approbations en attente",
    "task.inquiries": "Nouvelles demandes",
    "task.overdue": "Factures en retard",
    "task.security": "Alertes de sécurité",
    "task.emptyTitle": "Tout est fait",
    "task.emptySub": "Aucune tâche en attente – bravo.",
    "act.empty": "Aucune activité enregistrée.",
    "act.provider.approve": "Prestataire approuvé",
    "act.provider.reject": "Prestataire rejeté",
    "act.membership.update": "Adhésion modifiée",
    "sec.failed7d": "Connexions échouées (7j)",
    "sec.logins7d": "Connexions (7j)",
    "sec.lastEvents": "Derniers événements",
    "sec.allGood": "Aucune anomalie",
    "card.members": "Membres",
    "card.approved": "Approuvés",
    "card.synced": "Synchronisé",
    "matrix.title": "Matrice de santé des portails",
    "matrix.sub": "Tous les portails en un coup d'œil – état, validations, demandes, revenus & sync.",
    "matrix.col.portal": "Portail",
    "matrix.col.status": "Statut",
    "matrix.col.health": "État",
    "matrix.col.providers": "Prestataires",
    "matrix.col.approvals": "Validations",
    "matrix.col.inquiries": "Demandes",
    "matrix.col.packages": "Forfaits",
    "matrix.col.invoices": "Factures",
    "matrix.col.revenue": "Revenus",
    "matrix.col.sync": "Sync WP",
    "matrix.health.ok": "OK",
    "matrix.health.watch": "À surveiller",
    "matrix.health.risk": "Risque",
    "matrix.sync.synced": "Synchronisé",
    "matrix.sync.error": "Erreur",
    "matrix.sync.planned": "Prévu",
    "matrix.empty": "Aucun portail visible.",
    "nav.readiness": "Prêt pour le live",
    "ready.title": "Production Health Matrix",
    "ready.sub": "Statut live honnête par portail – ce qui est connecté, configuré, manquant ou démo. Aucune fausse donnée live.",
    "ready.legend": "Vert = connecté/configuré · Bleu = données seed · Ambre = non connecté/démo · Rouge = erreur",
    "ready.col.portal": "Portail",
    "ready.col.email": "E-mail (Brevo)",
    "ready.col.wordpress": "WordPress",
    "ready.col.payments": "Paiements",
    "ready.col.data": "Données",
    "ready.state.configured": "Configuré",
    "ready.state.connected": "Connecté",
    "ready.state.live": "Live",
    "ready.state.synthetic": "Données seed",
    "ready.state.demo": "Démo",
    "ready.state.mixed": "Partiellement démo",
    "ready.state.not_configured": "Non configuré",
    "ready.state.not_connected": "Non connecté",
    "ready.state.gateway_not_connected": "Pas de passerelle",
    "ready.state.empty": "Vide",
    "ready.state.error": "Erreur",
    "marker.not_configured": "Non configuré",
    "marker.gateway_not_connected": "Passerelle de paiement non connectée",
    "marker.database_only": "Base de données seulement – pas de vraie passerelle de paiement",
    "marker.demo": "Données démo",
    "marker.synthetic": "Données seed (synthétiques)",
    "marker.connected": "Connecté",
    "marker.error": "Erreur",
    "marker.payments.note": "Les paiements ne sont pour l'instant qu'un enregistrement – aucune passerelle réelle (Stripe/TWINT/Bexio) connectée.",
    "dash.favorites": "Favoris",
    "dash.account": "Profil",
    "dash.settings": "Paramètres",
    "account.personalData": "Données personnelles",
    "account.name": "Nom",
    "account.email": "E-mail",
    "account.phone": "Téléphone",
    "account.preferences": "Préférences",
    "account.language": "Langue",
    "account.emailNotifs": "Notifications e-mail",
    "account.emailNotifsHint": "Envoyées uniquement lorsque l'envoi d'e-mails (Brevo) est configuré.",
    "fav.discover": "Rechercher un prestataire …",
    "fav.onlyFavorites": "Favoris uniquement",
    "fav.none": "Aucun favori – touchez le cœur pour enregistrer un prestataire.",
    "fav.empty": "Aucun prestataire trouvé.",
    "fav.add": "Ajouter aux favoris",
    "fav.remove": "Retirer des favoris",
    "control.documents": "Documents",
    "control.documentsSub": "Contrats, justificatifs & documents sur tous les portails – protégés & basés sur les rôles.",
    "navgroup.overview": "Vue d'ensemble",
    "navgroup.management": "Gestion",
    "navgroup.insights": "Analyses",
    "control.noTeam": "Accès refusé — équipe KEWAG uniquement.",
    "dir.title": "KEWAGPortal",
    "dir.subtitle": "Un core. Plusieurs marques. Build once, configure often.",
    "dir.enter": "Ouvrir le portail",
    "dir.controlCta": "Vers le Control OS",
    "dash.ads": "Publicité",
    "dash.gallery": "Galerie",
    "promo.add": "Ajouter une promotion",
    "promo.none": "Aucune promotion",
    "promo.active": "Actif",
    "promo.delete": "Supprimer",
    "media.uploadCover": "Téléverser une couverture",
    "media.uploadGallery": "Ajouter une image",
    "media.uploading": "Téléversement …",
    "media.remove": "Retirer",
    "control.users": "Utilisateurs",
    "control.logs": "Journaux",
    "control.security": "Journal sécurité",
    "control.approvals": "Approbations",
    "control.role": "Rôle",
    "control.status": "Statut",
    "control.suspend": "Suspendre",
    "control.activate": "Activer",
    "control.userMgmt": "Utilisateurs & rôles",
    "control.searchUser": "Rechercher un utilisateur …",
    "promo.new": "Nouvelle promotion",
    "promo.edit": "Modifier",
    "promo.title": "Titre",
    "promo.subtitle": "Sous-titre",
    "promo.imageUrl": "Image",
    "promo.link": "Lien",
    "promo.inactive": "Inactif",
    "nav.more": "Plus",
    "nav.menu": "Menu",
    "dash.managePackages": "Gérer les forfaits",
    "pkg.name": "Nom du forfait",
    "pkg.price": "Prix",
    "pkg.features": "Prestations",
    "pkg.featuresHint": "Une prestation par ligne",
    "pkg.tier": "Niveau",
    "pkg.new": "Nouveau forfait",
    "pkg.setupFee": "Installation",
    "control.tabProviders": "Prestataires",
    "control.tabUsers": "Utilisateurs",
    "control.tabPackages": "Forfaits",
    "control.subscribers": "Abonnés",
    "control.customers": "Clients",
    "control.details": "Détails",
    "control.revenue": "Chiffre d'affaires",
    "control.openInvoices": "Factures ouvertes",
    "nav.reports": "Rapports",
    "dash.invoices": "Factures",
    "dash.report": "Rapport",
    "inv.new": "Nouvelle facture",
    "inv.provider": "Prestataire",
    "inv.amount": "Montant",
    "inv.due": "Échéance",
    "inv.method": "Mode de paiement",
    "inv.externalId": "N° externe",
    "inv.notes": "Note",
    "inv.markPaid": "Marquer comme payée",
    "inv.none": "Aucune facture",
    "inv.draft": "Brouillon",
    "inv.open": "Ouverte",
    "inv.paid": "Payée",
    "inv.overdue": "En retard",
    "inv.cancelled": "Annulée",
    "rep.inquiries": "Demandes",
    "rep.newProviders": "Nouveaux prestataires",
    "rep.revenue": "Chiffre d'affaires",
    "rep.monthly": "Évolution mensuelle",
    "rep.openInvoices": "Factures ouvertes",
    "rep.profileStatus": "Statut du profil",
    "rep.package": "Forfait",
    "map.title": "Liaison WordPress",
    "map.wpUrl": "URL WordPress",
    "map.listingId": "ID annonce Directorist",
    "map.publicUrl": "URL profil public",
    "map.markSynced": "Marquer comme synchronisé",
    "map.lastSync": "Dernière synchro",
    "map.edit": "Liaison",
    "sync.synced": "Synchronisé",
    "sync.pending": "En attente",
    "sync.not_linked": "Non lié",
    "sync.error": "Erreur",
    "roles.super_admin": "Super-admin",
    "roles.team_member": "Équipe KEWAG",
    "roles.portal_admin": "Admin portail",
    "roles.provider": "Prestataire",
    "roles.customer": "Client",
    "roles.candidate": "Candidat·e",
  },
  it: {
    "nav.discover": "Scopri",
    "nav.switchPortal": "Cambia portale",
    "nav.dashboard": "Dashboard",
    "nav.login": "Accedi",
    "nav.logout": "Esci",
    "nav.control": "Control OS",
    "nav.portals": "Portali",
    "nav.overview": "Panoramica",
    "nav.activity": "Attività",
    "common.loading": "Caricamento …",
    "common.back": "Indietro",
    "common.cancel": "Annulla",
    "common.save": "Salva",
    "common.saved": "Salvato",
    "common.close": "Chiudi",
    "common.all": "Tutti",
    "common.search": "Cerca",
    "common.results": "risultati",
    "common.none": "Nessuna voce",
    "common.readAll": "Tutti letti",
    "landing.exploreProviders": "Scopri i fornitori",
    "landing.becomeProvider": "Diventa fornitore",
    "landing.categories": "Categorie",
    "landing.featured": "Fornitori in evidenza",
    "landing.viewAll": "Vedi tutti",
    "landing.trusted": "Selezionato dal team KEWAG",
    "landing.providersLabel": "fornitori verificati",
    "auth.signIn": "Accedi",
    "auth.signUp": "Registrati",
    "auth.email": "E-mail",
    "auth.password": "Password",
    "auth.name": "Nome",
    "auth.asProvider": "Registrati come fornitore",
    "auth.continueGoogle": "Continua con Google",
    "auth.or": "oppure",
    "auth.noAccount": "Nessun account?",
    "auth.haveAccount": "Già registrato?",
    "auth.welcome": "Bentornato",
    "auth.createAccount": "Crea account",
    "auth.forgotPassword": "Password dimenticata?",
    "auth.loginTrouble": "Problemi di accesso? Contatta il supporto KEWAG",
    "auth.teamHint": "Fai parte del team KEWAG?",
    "auth.controlLogin": "Accedi al Control OS",
    "authx.encrypted": "Connessione crittografata",
    "authx.securedArea": "Area protetta",
    "authx.customerAccess": "Accesso app",
    "auth.accountType": "Mi registro come",
    "auth.selectAccountType": "Seleziona un tipo di account",
    "auth.acceptTerms": "Accetto i termini e l'informativa sulla privacy.",
    "auth.termsRequired": "Accetta i termini e la privacy.",
    "auth.teamAccess": "Accesso team",
    "auth.hasAccount": "Già registrato?",
    "auth.noAccount": "Nuovo qui?",
    "onb.title": "Completa il profilo",
    "onb.subtitle": "Ancora pochi dati e sei pronto.",
    "onb.step": "Passo 2 di 2",
    "onb.later": "Più tardi",
    "onb.finish": "Salva & apri il cockpit",
    "browse.filters": "Filtri",
    "browse.allCategories": "Tutte le categorie",
    "browse.allLocations": "Tutti i luoghi",
    "browse.noResults": "Nessun fornitore trovato",
    "provider.about": "Chi siamo",
    "provider.contact": "Contatto",
    "provider.sendInquiry": "Invia richiesta",
    "provider.subject": "Oggetto",
    "provider.message": "Messaggio",
    "provider.send": "Invia",
    "provider.reviews": "Recensioni",
    "provider.pendingNote": "Questo profilo è in attesa di approvazione.",
    "provider.inquirySent": "Richiesta inviata!",
    "provider.loginToInquire": "Accedi per richiedere",
    "dash.welcome": "Benvenuto",
    "dash.overview": "Panoramica",
    "dash.inbox": "Richieste in arrivo",
    "dash.myInquiries": "Le mie richieste",
    "dash.approvals": "Approvazioni",
    "dash.providers": "Fornitori",
    "dash.myProfile": "Il mio profilo",
    "dash.packages": "Pacchetti",
    "dash.notifications": "Notifiche",
    "stat.providers": "Fornitori",
    "stat.approved": "Approvati",
    "stat.pending": "In attesa",
    "stat.inquiries": "Richieste",
    "stat.open_inquiries": "Richieste aperte",
    "stat.rating": "Valutazione",
    "stat.reviews": "Recensioni",
    "status.new": "Nuovo",
    "status.in_progress": "In corso",
    "status.quoted": "Preventivo",
    "status.accepted": "Accettato",
    "status.closed": "Chiuso",
    "status.rejected": "Rifiutato",
    "status.pending": "In attesa",
    "status.approved": "Approvato",
    "inbox.select": "Seleziona una richiesta",
    "inbox.timeline": "Cronologia",
    "inbox.updateStatus": "Cambia stato",
    "inbox.reply": "Rispondi …",
    "inbox.send": "Invia",
    "inbox.customer": "Cliente",
    "inbox.provider": "Fornitore",
    "approve.approve": "Approva",
    "approve.reject": "Rifiuta",
    "approve.reason": "Motivo (facoltativo)",
    "approve.empty": "Nessuna approvazione in attesa",
    "profile.businessName": "Nome azienda",
    "profile.categories": "Categorie",
    "profile.location": "Luogo",
    "profile.description": "Descrizione",
    "profile.phone": "Telefono",
    "profile.website": "Sito web",
    "profile.cover": "URL immagine",
    "profile.create": "Crea profilo",
    "profile.status": "Stato",
    "pkg.current": "Pacchetto attuale",
    "pkg.choose": "Scegli",
    "pkg.subscribe": "Abbonati",
    "pkg.month": "mese",
    "pkg.free": "Gratis",
    "pkg.active": "Attivo",
    "control.title": "KEWAG Control OS",
    "control.subtitle": "Aggregazione tra portali",
    "control.totalProviders": "Fornitori",
    "control.totalInquiries": "Richieste",
    "control.totalUsers": "Membri",
    "control.pending": "Approvazioni aperte",
    "control.live": "Live",
    "control.skeleton": "Skeleton",
    "control.copyable": "Copiabile in 1–2 giorni",
    "control.openPortal": "Apri portale",
    "control.recentActivity": "Attività recente",
    "control.commandCenter": "Command Center",
    "control.allClear": "Tutto sotto controllo",
    "control.needsAttention": "punti richiedono attenzione",
    "control.today": "Importante oggi",
    "control.todaySub": "Ciò che richiede la tua attenzione",
    "control.review": "Rivedi",
    "kpi.providers": "Fornitori (totale)",
    "kpi.inquiries7d": "Nuove richieste (7g)",
    "kpi.approvals": "Approvazioni aperte",
    "kpi.subscriptions": "Abbonamenti attivi",
    "kpi.registrations7d": "Nuove registrazioni (7g)",
    "kpi.security": "Avvisi di sicurezza",
    "kpi.revenue": "Fatturato (pagato)",
    "kpi.vsPrev": "vs settimana prec.",
    "kpi.new7d": "nuovi (7g)",
    "task.approvals": "Approvazioni in attesa",
    "task.inquiries": "Nuove richieste",
    "task.overdue": "Fatture scadute",
    "task.security": "Avvisi di sicurezza",
    "task.emptyTitle": "Tutto fatto",
    "task.emptySub": "Nessuna attività in sospeso – ottimo.",
    "act.empty": "Nessuna attività registrata.",
    "act.provider.approve": "Fornitore approvato",
    "act.provider.reject": "Fornitore rifiutato",
    "act.membership.update": "Iscrizione aggiornata",
    "sec.failed7d": "Accessi falliti (7g)",
    "sec.logins7d": "Accessi (7g)",
    "sec.lastEvents": "Ultimi eventi",
    "sec.allGood": "Nessuna anomalia",
    "card.members": "Membri",
    "card.approved": "Approvati",
    "card.synced": "Sincronizzato",
    "matrix.title": "Matrice di salute dei portali",
    "matrix.sub": "Tutti i portali in un colpo d'occhio – stato, approvazioni, richieste, fatturato & sync.",
    "matrix.col.portal": "Portale",
    "matrix.col.status": "Stato",
    "matrix.col.health": "Salute",
    "matrix.col.providers": "Fornitori",
    "matrix.col.approvals": "Approvazioni",
    "matrix.col.inquiries": "Richieste",
    "matrix.col.packages": "Pacchetti",
    "matrix.col.invoices": "Fatture",
    "matrix.col.revenue": "Fatturato",
    "matrix.col.sync": "Sync WP",
    "matrix.health.ok": "OK",
    "matrix.health.watch": "Da monitorare",
    "matrix.health.risk": "Rischio",
    "matrix.sync.synced": "Sincronizzato",
    "matrix.sync.error": "Errore",
    "matrix.sync.planned": "Pianificato",
    "matrix.empty": "Nessun portale visibile.",
    "nav.readiness": "Pronto per il live",
    "ready.title": "Production Health Matrix",
    "ready.sub": "Stato live onesto per portale – cosa è connesso, configurato, mancante o demo. Nessun dato live falso.",
    "ready.legend": "Verde = connesso/configurato · Blu = dati seed · Ambra = non connesso/demo · Rosso = errore",
    "ready.col.portal": "Portale",
    "ready.col.email": "E-mail (Brevo)",
    "ready.col.wordpress": "WordPress",
    "ready.col.payments": "Pagamenti",
    "ready.col.data": "Dati",
    "ready.state.configured": "Configurato",
    "ready.state.connected": "Connesso",
    "ready.state.live": "Live",
    "ready.state.synthetic": "Dati seed",
    "ready.state.demo": "Demo",
    "ready.state.mixed": "Parz. demo",
    "ready.state.not_configured": "Non configurato",
    "ready.state.not_connected": "Non connesso",
    "ready.state.gateway_not_connected": "Nessun gateway",
    "ready.state.empty": "Vuoto",
    "ready.state.error": "Errore",
    "marker.not_configured": "Non configurato",
    "marker.gateway_not_connected": "Gateway di pagamento non connesso",
    "marker.database_only": "Solo database – nessun vero gateway di pagamento",
    "marker.demo": "Dati demo",
    "marker.synthetic": "Dati seed (sintetici)",
    "marker.connected": "Connesso",
    "marker.error": "Errore",
    "marker.payments.note": "I pagamenti al momento sono solo un record – nessun gateway reale (Stripe/TWINT/Bexio) connesso.",
    "dash.favorites": "Preferiti",
    "dash.account": "Profilo",
    "dash.settings": "Impostazioni",
    "account.personalData": "Dati personali",
    "account.name": "Nome",
    "account.email": "E-mail",
    "account.phone": "Telefono",
    "account.preferences": "Preferenze",
    "account.language": "Lingua",
    "account.emailNotifs": "Notifiche e-mail",
    "account.emailNotifsHint": "Inviate solo quando l'invio e-mail (Brevo) è configurato.",
    "fav.discover": "Cerca fornitore …",
    "fav.onlyFavorites": "Solo preferiti",
    "fav.none": "Nessun preferito – tocca il cuore per salvare un fornitore.",
    "fav.empty": "Nessun fornitore trovato.",
    "fav.add": "Aggiungi ai preferiti",
    "fav.remove": "Rimuovi dai preferiti",
    "control.documents": "Documenti",
    "control.documentsSub": "Contratti, prove e documenti su tutti i portali – protetti e basati sui ruoli.",
    "navgroup.overview": "Panoramica",
    "navgroup.management": "Gestione",
    "navgroup.insights": "Analisi",
    "control.noTeam": "Accesso negato — solo team KEWAG.",
    "dir.title": "KEWAGPortal",
    "dir.subtitle": "Un core. Molti brand. Build once, configure often.",
    "dir.enter": "Apri portale",
    "dir.controlCta": "Vai al Control OS",
    "dash.ads": "Pubblicità",
    "dash.gallery": "Galleria",
    "promo.add": "Aggiungi promozione",
    "promo.none": "Nessuna promozione",
    "promo.active": "Attivo",
    "promo.delete": "Elimina",
    "media.uploadCover": "Carica copertina",
    "media.uploadGallery": "Aggiungi immagine",
    "media.uploading": "Caricamento …",
    "media.remove": "Rimuovi",
    "control.users": "Utenti",
    "control.logs": "Log",
    "control.security": "Log sicurezza",
    "control.approvals": "Approvazioni",
    "control.role": "Ruolo",
    "control.status": "Stato",
    "control.suspend": "Sospendi",
    "control.activate": "Attiva",
    "control.userMgmt": "Utenti & ruoli",
    "control.searchUser": "Cerca utente …",
    "promo.new": "Nuova promozione",
    "promo.edit": "Modifica",
    "promo.title": "Titolo",
    "promo.subtitle": "Sottotitolo",
    "promo.imageUrl": "Immagine",
    "promo.link": "Link",
    "promo.inactive": "Inattivo",
    "nav.more": "Altro",
    "nav.menu": "Menu",
    "dash.managePackages": "Gestisci pacchetti",
    "pkg.name": "Nome pacchetto",
    "pkg.price": "Prezzo",
    "pkg.features": "Funzioni",
    "pkg.featuresHint": "Una funzione per riga",
    "pkg.tier": "Livello",
    "pkg.new": "Nuovo pacchetto",
    "pkg.setupFee": "Setup",
    "control.tabProviders": "Fornitori",
    "control.tabUsers": "Utenti",
    "control.tabPackages": "Pacchetti",
    "control.subscribers": "Abbonati",
    "control.customers": "Clienti",
    "control.details": "Dettagli",
    "control.revenue": "Fatturato",
    "control.openInvoices": "Fatture aperte",
    "nav.reports": "Report",
    "dash.invoices": "Fatture",
    "dash.report": "Report",
    "inv.new": "Nuova fattura",
    "inv.provider": "Fornitore",
    "inv.amount": "Importo",
    "inv.due": "Scadenza",
    "inv.method": "Metodo di pagamento",
    "inv.externalId": "N. esterno",
    "inv.notes": "Nota",
    "inv.markPaid": "Segna come pagata",
    "inv.none": "Nessuna fattura",
    "inv.draft": "Bozza",
    "inv.open": "Aperta",
    "inv.paid": "Pagata",
    "inv.overdue": "Scaduta",
    "inv.cancelled": "Annullata",
    "rep.inquiries": "Richieste",
    "rep.newProviders": "Nuovi fornitori",
    "rep.revenue": "Fatturato",
    "rep.monthly": "Andamento mensile",
    "rep.openInvoices": "Fatture aperte",
    "rep.profileStatus": "Stato profilo",
    "rep.package": "Pacchetto",
    "map.title": "Collegamento WordPress",
    "map.wpUrl": "URL WordPress",
    "map.listingId": "ID annuncio Directorist",
    "map.publicUrl": "URL profilo pubblico",
    "map.markSynced": "Segna come sincronizzato",
    "map.lastSync": "Ultima sincro",
    "map.edit": "Collegamento",
    "sync.synced": "Sincronizzato",
    "sync.pending": "In attesa",
    "sync.not_linked": "Non collegato",
    "sync.error": "Errore",
    "roles.super_admin": "Super-admin",
    "roles.team_member": "Team KEWAG",
    "roles.portal_admin": "Admin portale",
    "roles.provider": "Fornitore",
    "roles.customer": "Cliente",
    "roles.candidate": "Candidato/a",
  },
  en: {
    "nav.discover": "Discover",
    "nav.switchPortal": "Switch portal",
    "nav.dashboard": "Dashboard",
    "nav.login": "Sign in",
    "nav.logout": "Sign out",
    "nav.control": "Control OS",
    "nav.portals": "Portals",
    "nav.overview": "Overview",
    "nav.activity": "Activity",
    "common.loading": "Loading …",
    "common.back": "Back",
    "common.cancel": "Cancel",
    "common.save": "Save",
    "common.saved": "Saved",
    "common.close": "Close",
    "common.all": "All",
    "common.search": "Search",
    "common.results": "results",
    "common.none": "No entries",
    "common.readAll": "All read",
    "landing.exploreProviders": "Explore providers",
    "landing.becomeProvider": "Become a provider",
    "landing.categories": "Categories",
    "landing.featured": "Featured providers",
    "landing.viewAll": "View all",
    "landing.trusted": "Curated by the KEWAG team",
    "landing.providersLabel": "verified providers",
    "auth.signIn": "Sign in",
    "auth.signUp": "Sign up",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.name": "Name",
    "auth.asProvider": "Register as a provider",
    "auth.continueGoogle": "Continue with Google",
    "auth.or": "or",
    "auth.noAccount": "No account yet?",
    "auth.haveAccount": "Already registered?",
    "auth.welcome": "Welcome back",
    "auth.createAccount": "Create account",
    "auth.forgotPassword": "Forgot password?",
    "auth.loginTrouble": "Trouble signing in? Contact KEWAG support",
    "auth.teamHint": "Part of the KEWAG team?",
    "auth.controlLogin": "Go to Control OS login",
    "authx.encrypted": "Encrypted connection",
    "authx.securedArea": "Protected area",
    "authx.customerAccess": "App access",
    "auth.accountType": "I'm signing up as",
    "auth.selectAccountType": "Please choose an account type",
    "auth.acceptTerms": "I accept the Terms and Privacy Policy.",
    "auth.termsRequired": "Please accept the Terms & Privacy.",
    "auth.teamAccess": "Team access",
    "auth.hasAccount": "Already registered?",
    "auth.noAccount": "New here?",
    "onb.title": "Complete your profile",
    "onb.subtitle": "Just a few details and you're ready to go.",
    "onb.step": "Step 2 of 2",
    "onb.later": "Do it later",
    "onb.finish": "Save & open cockpit",
    "browse.filters": "Filters",
    "browse.allCategories": "All categories",
    "browse.allLocations": "All locations",
    "browse.noResults": "No providers found",
    "provider.about": "About",
    "provider.contact": "Contact",
    "provider.sendInquiry": "Send inquiry",
    "provider.subject": "Subject",
    "provider.message": "Message",
    "provider.send": "Send",
    "provider.reviews": "reviews",
    "provider.pendingNote": "This profile is awaiting approval.",
    "provider.inquirySent": "Inquiry sent!",
    "provider.loginToInquire": "Sign in to inquire",
    "dash.welcome": "Welcome",
    "dash.overview": "Overview",
    "dash.inbox": "Inquiry inbox",
    "dash.myInquiries": "My inquiries",
    "dash.approvals": "Approvals",
    "dash.providers": "Providers",
    "dash.myProfile": "My profile",
    "dash.packages": "Packages",
    "dash.notifications": "Notifications",
    "stat.providers": "Providers",
    "stat.approved": "Approved",
    "stat.pending": "Pending",
    "stat.inquiries": "Inquiries",
    "stat.open_inquiries": "Open inquiries",
    "stat.rating": "Rating",
    "stat.reviews": "Reviews",
    "status.new": "New",
    "status.in_progress": "In progress",
    "status.quoted": "Quoted",
    "status.accepted": "Accepted",
    "status.closed": "Closed",
    "status.rejected": "Rejected",
    "status.pending": "Pending",
    "status.approved": "Approved",
    "inbox.select": "Select an inquiry",
    "inbox.timeline": "Timeline",
    "inbox.updateStatus": "Update status",
    "inbox.reply": "Reply …",
    "inbox.send": "Send",
    "inbox.customer": "Customer",
    "inbox.provider": "Provider",
    "approve.approve": "Approve",
    "approve.reject": "Reject",
    "approve.reason": "Reason (optional)",
    "approve.empty": "No pending approvals",
    "profile.businessName": "Business name",
    "profile.categories": "Categories",
    "profile.location": "Location",
    "profile.description": "Description",
    "profile.phone": "Phone",
    "profile.website": "Website",
    "profile.cover": "Cover image URL",
    "profile.create": "Create profile",
    "profile.status": "Status",
    "pkg.current": "Current plan",
    "pkg.choose": "Choose",
    "pkg.subscribe": "Subscribe",
    "pkg.month": "month",
    "pkg.free": "Free",
    "pkg.active": "Active",
    "control.title": "KEWAG Control OS",
    "control.subtitle": "Cross-portal aggregation",
    "control.totalProviders": "Total providers",
    "control.totalInquiries": "Total inquiries",
    "control.totalUsers": "Total members",
    "control.pending": "Open approvals",
    "control.live": "Live",
    "control.skeleton": "Skeleton",
    "control.copyable": "Copyable in 1–2 days",
    "control.openPortal": "Open portal",
    "control.recentActivity": "Recent activity",
    "control.commandCenter": "Command Center",
    "control.allClear": "All clear",
    "control.needsAttention": "items need attention",
    "control.today": "Today important",
    "control.todaySub": "What needs your attention now",
    "control.review": "Review now",
    "kpi.providers": "Total providers",
    "kpi.inquiries7d": "New inquiries (7d)",
    "kpi.approvals": "Open approvals",
    "kpi.subscriptions": "Active subs",
    "kpi.registrations7d": "New registrations (7d)",
    "kpi.security": "Security alerts",
    "kpi.revenue": "Revenue (paid)",
    "kpi.vsPrev": "vs prev. week",
    "kpi.new7d": "new (7d)",
    "task.approvals": "Approvals pending",
    "task.inquiries": "New inquiries",
    "task.overdue": "Overdue invoices",
    "task.security": "Security alerts",
    "task.emptyTitle": "All done",
    "task.emptySub": "No open tasks – well done.",
    "act.empty": "No activity recorded yet.",
    "act.provider.approve": "Provider approved",
    "act.provider.reject": "Provider rejected",
    "act.membership.update": "Membership updated",
    "sec.failed7d": "Failed logins (7d)",
    "sec.logins7d": "Logins (7d)",
    "sec.lastEvents": "Last events",
    "sec.allGood": "No anomalies",
    "card.members": "Members",
    "card.approved": "Approved",
    "card.synced": "Synced",
    "matrix.title": "Portal Health Matrix",
    "matrix.sub": "The whole fleet at a glance – health, approvals, inquiries, revenue & sync.",
    "matrix.col.portal": "Portal",
    "matrix.col.status": "Status",
    "matrix.col.health": "Health",
    "matrix.col.providers": "Providers",
    "matrix.col.approvals": "Approvals",
    "matrix.col.inquiries": "Inquiries",
    "matrix.col.packages": "Packages",
    "matrix.col.invoices": "Invoices",
    "matrix.col.revenue": "Revenue",
    "matrix.col.sync": "WP Sync",
    "matrix.health.ok": "OK",
    "matrix.health.watch": "Watch",
    "matrix.health.risk": "Risk",
    "matrix.sync.synced": "Synced",
    "matrix.sync.error": "Error",
    "matrix.sync.planned": "Planned",
    "matrix.empty": "No portals visible.",
    "nav.readiness": "Live readiness",
    "ready.title": "Production Health Matrix",
    "ready.sub": "Honest live status per portal – what is connected, configured, missing or demo. No fake live data.",
    "ready.legend": "Green = connected/configured · Blue = seed data · Amber = not connected/demo · Red = error",
    "ready.col.portal": "Portal",
    "ready.col.email": "Email (Brevo)",
    "ready.col.wordpress": "WordPress",
    "ready.col.payments": "Payments",
    "ready.col.data": "Data",
    "ready.state.configured": "Configured",
    "ready.state.connected": "Connected",
    "ready.state.live": "Live",
    "ready.state.synthetic": "Seed data",
    "ready.state.demo": "Demo",
    "ready.state.mixed": "Partly demo",
    "ready.state.not_configured": "Not configured",
    "ready.state.not_connected": "Not connected",
    "ready.state.gateway_not_connected": "No gateway",
    "ready.state.empty": "Empty",
    "ready.state.error": "Error",
    "marker.not_configured": "Not configured",
    "marker.gateway_not_connected": "Payment gateway not connected",
    "marker.database_only": "Database only – no real payment gateway",
    "marker.demo": "Demo data",
    "marker.synthetic": "Seed data (synthetic)",
    "marker.connected": "Connected",
    "marker.error": "Error",
    "marker.payments.note": "Payments are currently record-only – no real gateway (Stripe/TWINT/Bexio) connected.",
    "dash.favorites": "Favorites",
    "dash.account": "Profile",
    "dash.settings": "Settings",
    "account.personalData": "Personal data",
    "account.name": "Name",
    "account.email": "Email",
    "account.phone": "Phone",
    "account.preferences": "Preferences",
    "account.language": "Language",
    "account.emailNotifs": "Email notifications",
    "account.emailNotifsHint": "Only delivered once email sending (Brevo) is configured.",
    "fav.discover": "Search providers …",
    "fav.onlyFavorites": "Favorites only",
    "fav.none": "No favorites yet – tap the heart to save providers.",
    "fav.empty": "No providers found.",
    "fav.add": "Add to favorites",
    "fav.remove": "Remove from favorites",
    "control.documents": "Documents",
    "control.documentsSub": "Contracts, proofs & papers across all portals – protected & role-based.",
    "navgroup.overview": "Overview",
    "navgroup.management": "Management",
    "navgroup.insights": "Insights",
    "control.noTeam": "Access denied — KEWAG team only.",
    "dir.title": "KEWAGPortal",
    "dir.subtitle": "One core. Many brands. Build once, configure often.",
    "dir.enter": "Open portal",
    "dir.controlCta": "Go to Control OS",
    "dash.ads": "Advertising",
    "dash.gallery": "Gallery",
    "promo.add": "Add promotion",
    "promo.none": "No promotions",
    "promo.active": "Active",
    "promo.delete": "Delete",
    "media.uploadCover": "Upload cover",
    "media.uploadGallery": "Add image",
    "media.uploading": "Uploading …",
    "media.remove": "Remove",
    "control.users": "Users",
    "control.logs": "Logs",
    "control.security": "Security log",
    "control.approvals": "Approvals",
    "control.role": "Role",
    "control.status": "Status",
    "control.suspend": "Suspend",
    "control.activate": "Activate",
    "control.userMgmt": "Users & roles",
    "control.searchUser": "Search user …",
    "promo.new": "New promotion",
    "promo.edit": "Edit",
    "promo.title": "Title",
    "promo.subtitle": "Subtitle",
    "promo.imageUrl": "Image",
    "promo.link": "Link",
    "promo.inactive": "Inactive",
    "nav.more": "More",
    "nav.menu": "Menu",
    "dash.managePackages": "Manage packages",
    "pkg.name": "Package name",
    "pkg.price": "Price",
    "pkg.features": "Features",
    "pkg.featuresHint": "One feature per line",
    "pkg.tier": "Tier",
    "pkg.new": "New package",
    "pkg.setupFee": "Setup fee",
    "control.tabProviders": "Providers",
    "control.tabUsers": "Users",
    "control.tabPackages": "Packages",
    "control.subscribers": "Subscribers",
    "control.customers": "Customers",
    "control.details": "Details",
    "control.revenue": "Revenue",
    "control.openInvoices": "Open invoices",
    "nav.reports": "Reports",
    "dash.invoices": "Invoices",
    "dash.report": "Report",
    "inv.new": "New invoice",
    "inv.provider": "Provider",
    "inv.amount": "Amount",
    "inv.due": "Due date",
    "inv.method": "Payment method",
    "inv.externalId": "External no.",
    "inv.notes": "Note",
    "inv.markPaid": "Mark as paid",
    "inv.none": "No invoices",
    "inv.draft": "Draft",
    "inv.open": "Open",
    "inv.paid": "Paid",
    "inv.overdue": "Overdue",
    "inv.cancelled": "Cancelled",
    "rep.inquiries": "Inquiries",
    "rep.newProviders": "New providers",
    "rep.revenue": "Revenue",
    "rep.monthly": "Monthly trend",
    "rep.openInvoices": "Open invoices",
    "rep.profileStatus": "Profile status",
    "rep.package": "Package",
    "map.title": "WordPress link",
    "map.wpUrl": "WordPress URL",
    "map.listingId": "Directorist listing ID",
    "map.publicUrl": "Public profile URL",
    "map.markSynced": "Mark as synced",
    "map.lastSync": "Last sync",
    "map.edit": "Link",
    "sync.synced": "Synced",
    "sync.pending": "Pending",
    "sync.not_linked": "Not linked",
    "sync.error": "Error",
    "roles.super_admin": "Super admin",
    "roles.team_member": "KEWAG team",
    "roles.portal_admin": "Portal admin",
    "roles.provider": "Provider",
    "roles.customer": "Customer",
    "roles.candidate": "Candidate",
  },
};
